import { supabase } from "@/api/supabaseClient";

export type GeoPlace = {
  id: string;
  name: string;
  /** Bundesland / federal state */
  state: string | null;
  /** Stadt / parent city (e.g. for districts) */
  city: string | null;
  /** Landkreis / county */
  county: string | null;
  countryCode: string;
  lat: number | null;
  lon: number | null;
  plz?: string | null;
  /** city | district – Stadt vs. Stadtteil */
  placeType?: string | null;
};

export type GeoSearchOptions = {
  /** Optional: Nutzer-Koordinaten für „nahe zuerst“. */
  userLat?: number | null;
  userLon?: number | null;
};

/** Zeile aus RPC search_geo_places (Snake_case wie in Postgres). */
type SearchGeoPlacesRow = {
  id: string;
  name: string;
  state?: string | null;
  city?: string | null;
  county?: string | null;
  country_code?: string | null;
  lat?: number | null;
  lon?: number | null;
  plz?: string | null;
  place_type?: string | null;
};

export class GeoPlacesApi {
  static async search(
    query: string,
    limit = 12,
    options?: GeoSearchOptions
  ): Promise<GeoPlace[]> {
    const q = query.trim();
    if (q.length < 2 && !/^\d{5}$/.test(q)) return [];

    const { data, error } = await supabase.rpc("search_geo_places", {
      q,
      lim: limit,
      user_lat: options?.userLat ?? null,
      user_lon: options?.userLon ?? null,
    });

    if (error) throw error;

    const rows = (data ?? []) as SearchGeoPlacesRow[];
    return rows.map((r) => ({
      id: r.id,
      name: r.name,
      state: r.state ?? null,
      city: r.city ?? null,
      county: r.county ?? null,
      countryCode: r.country_code ?? "DE",
      lat: r.lat ?? null,
      lon: r.lon ?? null,
      plz: r.plz ?? null,
      placeType: r.place_type ?? null,
    }));
  }
}
